import React from 'react';

import styles from '@/views/components/SearchInput/SearchInput.module.scss';

const SearchInput = ({ label, placeholder, searchedValue, value, setValue, searchFunction }) => {
	const clearValue = () => {
		setValue("");
		searchFunction("");
	};

	return (
		<div className={ styles['searchbar--item'] }>
			<label className={ styles['searchbar--label'] }>{label}</label>
			<div className={ styles['searchbar--bar'] }>
				<input
					placeholder={ placeholder }
					className={ styles['searchbar--input'] }
					type='text'
					name='query'
					value={ value }
					onChange={ (ev) => setValue(ev.target.value) }
					onKeyPress={ (ev) => {
						if (ev.charCode === 13) {
							searchFunction(value);
						}
					} }
				/>
				<button
					className={ searchedValue.length === 0 && value.length === 0 ? `${ styles['searchbar--input-clear'] } ${ styles['disabled'] }` : styles['searchbar--input-clear'] }
					onClick={ clearValue }
				>
					<i className='icon-close icon' />
				</button>
				<div
					className={ searchedValue === value ? `${ styles['searchbar--input-submit'] } ${ styles['disabled'] }` : styles['searchbar--input-submit'] }
					onClick={ () => searchFunction(value) }
				>
					<i className='icon-search icon' />
				</div>
			</div>
		</div>
	);
};

export default SearchInput;